import {
  CheckoutEvents,
  checkoutEventEmitter,
} from "@made-people/grease-checkout";
import { useEffect } from "react";
import { useMmGtm } from "../mm-gtm-context";
import { gtmPushCheckoutEvent } from "../mm-gtm-helpers";

export const MmGtmEventBeginCheckout = () => {
  const { pusher, frontendContext } = useMmGtm();

  useEffect(() => {
    const handleCheckoutStarted = (
      params: CheckoutEvents["checkoutStarted"],
    ) => {
      gtmPushCheckoutEvent(
        pusher,
        "checkout",
        "start",
        params.cart,
        frontendContext,
      );
    };

    checkoutEventEmitter.on("checkoutStarted", handleCheckoutStarted);
    return () => {
      checkoutEventEmitter.off("checkoutStarted", handleCheckoutStarted);
    };
  }, []);

  return null;
};
